import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import utilities from "./utilities/utility";
import firebase from "firebase";
import { firestorePlugin } from "vuefire";
import VueTheMask from "vue-the-mask";
import store from "./store";
import "./registerServiceWorker";
import { VueMasonryPlugin } from "vue-masonry";
var VueScrollTo = require("vue-scrollto");

Vue.use(VueMasonryPlugin);
Vue.use(VueScrollTo);
Vue.use(VueTheMask);
Vue.use(require("vue-moment"));
Vue.use(firestorePlugin);
Vue.mixin(utilities.mixin());

Vue.config.productionTip = false;

let app;
firebase.auth().onAuthStateChanged((user) => {
  if (!app) {
    app = new Vue({
      store,
      router,
      render: (h) => h(App),
      created() {
        if (this.$store.state.kiosk && this.$store.state.client) {
          this.$store.dispatch("updateClient");
        }
      },
    }).$mount("#app");
  }
});
